import { GoogleTagManager } from '@next/third-parties/google'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/next'

import { ga4UserIdEntry } from '@web-app/lib/analytics/ga4UserId'

// Every Vercel deploy loads the published container; local runs load nothing.
// Which GA4 property receives hits and which vendor tags run is decided in
// the container by hostname, so production and preview ask for the same thing.
export const gtmFor = (deploy: string | undefined) =>
  deploy === 'production' || deploy === 'preview'
    ? { gtmId: 'GTM-TVJ3V28V' }
    : null

const gtm = gtmFor(process.env.NEXT_PUBLIC_VERCEL_ENV)

// Dashboard-feeding vendors (StatCounter, Clarity, the ad pixels) are tags in
// the container, consent-gated there. Only the cookieless host analytics and
// the container loader live in code. Page code reaches the tag through
// @ui/lib/googleTag.
//
// A signed-in page's first hit must already carry the user id, so it enters
// the data layer ahead of the container; the auth client pushes the changes.
export const MeasurementTags = ({ userId }: { userId?: string }) => (
  <>
    <Analytics />
    <SpeedInsights />
    {gtm && (
      <GoogleTagManager
        {...gtm}
        {...(userId ? { dataLayer: ga4UserIdEntry(userId) } : {})}
      />
    )}
  </>
)
